import { render, staticRenderFns } from "./ContentSlideTemplateItemV2.vue?vue&type=template&id=17c5a63e&scoped=true&"
import script from "./ContentSlideTemplateItemV2.vue?vue&type=script&lang=js&"
export * from "./ContentSlideTemplateItemV2.vue?vue&type=script&lang=js&"
import style0 from "./ContentSlideTemplateItemV2.vue?vue&type=style&index=0&id=17c5a63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c5a63e",
  null
  
)

export default component.exports